export enum BUTTON_ACTIONS {
  OPEN_MODAL = 'SUBMIT_WITH_MODAL', // default
  CHANGE_STATE = 'CHANGE_STATE'
}

export enum APPLICATION_TYPE {
  PATHWAY_NAVIGATOR = 'PATHWAYS-NAVIGATOR-APP'
}
